import { Directive, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NavService } from '../../core/nav.service';
import { Lesson } from '../shared/lesson';

@Directive({
  selector: 'app-lesson-nav' // tslint:disable-line:directive-selector
})
export class LessonNavDirective implements OnDestroy {
  constructor(private route: ActivatedRoute, private nav: NavService) { }

  ngOnDestroy() {
    this.nav.subActivated = null;
    this.nav.navActions = null;
  }

  @Input() set lesson(lesson: Lesson) {
    if (lesson) {
      this.nav.subActivated = [lesson.$key];
      this.nav.updateNavActions();
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson/lesson-nav.directive.ts